import { postRequest } from 'services/requests';

const services = {
    getAssignments: (body) => postRequest(`/get-assignments`, body),
    getAssignment: (body) => postRequest(`/get-assignment`, body),
    getEnvData: (body) => postRequest(`/get-sections`, body),
    getCourseUsers: (body) => postRequest(`/get-course-users`, body),
    getSubmissions: (body) => postRequest(`/get-submissions`, body),
    getSubmissionFile: (body) => postRequest(`/get-submission-file`, body),
    postGrade: (body) => postRequest(`/post-grade`, body),
    pushRubric: (body) => postRequest(`/push-rubric`, body),
    listAPIUsers: (body) => postRequest(`/list-api-users`, body),
    createAPICourse: (body) => postRequest(`/create-course`, body),
    getAPICourses: (body) => postRequest(`/get-courses`, body),
};

export default services;
